import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

// Material Kit 2 React themes
import theme from "assets/theme";

// Import the login view and routes
import SignInBasic from "views/signin/index";
import routes from "routes";
import Logout from "views/logout/logout";
import { KeycloakProvider, useKeycloak } from "Keycloak/KeycloakContext";
import { Box, CircularProgress, Typography } from "@mui/material";

const AppContent = () => {
  const { userAuthenticated } = useKeycloak();

  const { pathname } = useLocation();
  const signInData = useSelector((state) => state.signIn);
  const isAuthenticatedRedux = signInData.isAuthenticated;

  // Retrieve authentication data and user's country
  const datosRecuperados = JSON.parse(localStorage.getItem("sesion"));
  const isAuthenticatedSessionStorage = !!datosRecuperados;
  const userCountry =
    datosRecuperados?.rols?.[0]?.country?.countryName || "default"; //

  // Set page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  // Function to render routes
  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return isAuthenticatedSessionStorage ? (
          <Route
            exact
            path={route.route}
            element={route.component}
            key={route.name}
          />
        ) : (
          <Route
            path={route.route}
            element={<Navigate to="/views/signin" replace />}
            key={route.name}
          />
        );
      }

      return null;
    });

  return (
    <>
      {userAuthenticated ? (
        <>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <Routes>
              {/* Render routes based on authentication */}
              {isAuthenticatedSessionStorage ? (
                getRoutes(routes)
              ) : (
                <Route path="*" element={<Navigate to="/views/signin" />} />
              )}

              {/* Route for login */}
              <Route path="/views/signin" element={<SignInBasic />} />

              {/* Route for logout */}
              <Route path="/views/logout" element={<Logout />} />

              {/* Country-specific redirection */}
              <Route
                path="*"
                element={
                  !isAuthenticatedRedux ? (
                    <Navigate to="/views/signin" />
                  ) : userCountry === "Costa Rica" ? (
                    <Navigate to="/views/countries/cr/home" />
                  ) : userCountry === "Peru" ? (
                    <Navigate to="/views/countries/pe/home" />
                  ) : userCountry === "Mexico" ? (
                    <Navigate to="/views/countries/mx/home" />
                  ) : (
                    <Navigate to="/views/home" />
                  )
                }
              />
            </Routes>
          </ThemeProvider>
        </>
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100vh",
            bgcolor: "background.default",
          }}
        >
          <CircularProgress size={50} />
          <Typography variant="h6" sx={{ mt: 2, color: "text.secondary" }}>
            Loading...
          </Typography>
        </Box>
      )}
    </>
  );
};

const App = () => {
  return (
    <KeycloakProvider>
      <AppContent />
    </KeycloakProvider>
  );
};

export default App;
